'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('../helpers/utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Component: Example script
 * ------------------------------------------------------------------------------
 * An example file that contains scripts to function.
 *
 * @namespace example
 */
var selectors = {
  toggleSelector: '[js-gift-card="toggle"]',
  message: '[js-gift-card="message"]'
};

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */

exports.default = function () {

  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    toggleSelector: document.querySelector(selectors.toggleSelector),
    message: document.querySelector(selectors.message)
  };

  /**
   * Initialise component.
   */
  function init() {
    setTriggerEvents();
  }

  /**
   * Set trigger listeners.
   */
  function setTriggerEvents() {
    (0, _utils.on)('change', nodeSelectors.toggleSelector, function () {
      var id = nodeSelectors.toggleSelector.dataset.giftWrapId;
      if (nodeSelectors.toggleSelector.checked === true) {
        set(id);
      } else {
        remove(id);
      }
    });
    (0, _utils.on)('change', nodeSelectors.message, function () {
      var message = nodeSelectors.message.value;
      setMessage(message);
    });
  }

  function set(id) {
    _axios2.default.post('/cart/update.js', {
      updates: (0, _defineProperty3.default)({}, id, 1),
      attributes: { 'gift-wrapping': 'true' }
    }).then(function (response) {
      return response;
    }).catch(function (error) {
      nodeSelectors.toggleSelector.checked = false;
      return error;
    });
  }

  function remove(id) {
    _axios2.default.post('/cart/update.js', {
      updates: (0, _defineProperty3.default)({}, id, 0),
      attributes: { 'gift-wrapping': '' }
    }).then(function (response) {
      return response;
    }).catch(function (error) {
      nodeSelectors.toggleSelector.checked = true;
      return error;
    });
  }

  function setMessage(message) {
    _axios2.default.post('/cart/update.js', {
      attributes: { 'gift-note': message }
    }).then(function (response) {
      return response;
    }).catch(function (error) {
      return error;
    });
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init
  });
};